export const FILE_TYPE_EXTENSION_MAP = {
  Images: ["jpg", "jpeg", "png", "gif", "tiff", "svg"],
  Videos: ["mpg", "mp4", "mov", "avi"],
  Spreadsheets: ["xlsx", "xls", "csv"],
  Documents: ["pdf", "docx"],
  Text: ["txt", "log"],
  JSON: ["json"],
} as const;

export const FILE_TYPE_OPTIONS = Object.keys(FILE_TYPE_EXTENSION_MAP);

// Flattened extension -> kind map for icon rendering.
export const EXTENSION_KIND_MAP: Record<string, string> = Object.entries(
  FILE_TYPE_EXTENSION_MAP
).reduce((acc, [kind, exts]) => {
  exts.forEach((ext) => {
    acc[ext] = kind.toLowerCase();
  });
  return acc;
}, {} as Record<string, string>);
